<template>
  <div>
    <v-switch
      v-on="$listeners"
      v-bind="[$attrs, $props]"
      class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
      inset
      dense
      hide-details
      color="secondary"
    />
    <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
      {{ labelText }}
    </p>
  </div>
</template>
<script>
export default {
  props: {
    labelText: {
      type: String
    }
  }
};
</script>
